import React from "react";
import teamPhoto from '../../Images/team-new.jpg';

const ACCENT = "#C2FB6B";
const BG = "#0B2B40";

export default function TeamShowcase() {
  return (
    <section className="relative w-full overflow-hidden" style={{ backgroundColor: BG }}>
      {/* background shapes like reference */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-32 h-[520px] w-[520px] rounded-full bg-white/5 blur-2xl" />
        <div className="absolute right-[-180px] top-[80px] h-[620px] w-[620px] rounded-full bg-white/5 blur-2xl" />
        <div className="absolute right-[-40px] top-[120px] h-[520px] w-[520px] rounded-full bg-white/5 blur-2xl" />
      </div>

      <div className="relative mx-auto max-w-6xl px-4 py-12 sm:px-6 md:py-16">
        <div className="text-center">
          <div className="text-xs font-semibold tracking-widest uppercase" style={{ color: ACCENT }}>
            Unser Team
          </div>
          <h2 className="mt-3 text-2xl font-semibold text-white sm:text-3xl">
            Die Menschen hinter Ihrem Projekt
          </h2>
        </div>

        {/* double frame + slight offset */}
        <div className="relative mt-8 md:mt-10">
          <div
            className="absolute inset-0 hidden translate-x-3 translate-y-3 rounded-[28px] sm:block"
            style={{ border: `2px solid rgba(194,251,107,0.35)` }}
          />
          <div
            className="relative rounded-[20px] bg-white/5 p-2 backdrop-blur sm:rounded-[28px] sm:p-3"
            style={{
              border: `2px solid ${ACCENT}`,
              boxShadow: "0 18px 45px rgba(0,0,0,0.35)",
            }}
          >
            <img
              src={teamPhoto}
              alt="Das Team"
              width={1376}
              height={768}
              loading="lazy"
              className="block h-auto w-full rounded-[14px] object-cover sm:rounded-[20px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
